import { render, staticRenderFns } from "./TextAreaExpandable.vue?vue&type=template&id=26a546a7&scoped=true&"
import script from "./TextAreaExpandable.vue?vue&type=script&lang=js&"
export * from "./TextAreaExpandable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a546a7",
  null
  
)

export default component.exports